@if (highlightPrice) {
  <store-highlight-pricing
    [pricing]="pricing"
    [billedProduct]="billedProduct"
    [highlightPrice]="highlightPrice"
    [isAddon]="isAddon"
    [hasVerifiedContract]="hasVerifiedContract"
    [wrapFrequency]="wrapFrequency"
    [loaded]="loaded"
    [useAbbreviatedFrequency]="useAbbreviatedFrequency"
  ></store-highlight-pricing>
}
@if (!highlightPrice) {
  <store-table-pricing
    [pricing]="pricing"
    [highlightPrice]="highlightPrice"
    [billedProduct]="billedProduct"
    [hasVerifiedContract]="hasVerifiedContract"
    [loaded]="loaded"
    [showAllPrices]="showAllPrices"
    [showIsStartingAt]="showIsStartingAt"
  ></store-table-pricing>
}
